import type { U3129InitLUPersonalization } from '../U3129Service';
import { u2000HideExpenseAndEquipmentTabs } from '../../u2000Core/tools/u2000HideExpenseAndEquipmentTabs';

/** BL-0675 : personnalisation org — masquer onglets Dépenses et Équipement. */
export function u3129HideExpenseAndEquipmentTabs(
  personalization?: U3129InitLUPersonalization | null,
): boolean {
  return u2000HideExpenseAndEquipmentTabs(personalization);
}

/** Identifiants d’onglets masqués lorsque le flag perso est actif. */
export const U3129_HIDDEN_EXPENSE_EQUIPMENT_TAB_IDS = ['tabExpenses', 'tabEquipment'] as const;
